import { Component, inject } from '@angular/core';
import { VendorCompanyCodeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorCompanyCodeCreateDto,
  VendorCompanyCodeDto,
  VendorCompanyCodeExcelDownloadDto,
  VendorCompanyCodeUpdateDto,
} from '../proxy/controlling/dtos/vendor-company-code';
import { VENDORCOMPANYCODE_CONFIG, VENDORCOMPANYCODE_FIELDS } from './vendor-company-code.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-company-code',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorCompanyCodeService, ConfirmationService],
  templateUrl: './vendor-company-code.html',
  styleUrl: './vendor-company-code.scss',
})
export class VendorCompanyCode extends BaseHierarchicalCrudComponent<
  VendorCompanyCodeDto,
  VendorCompanyCodeCreateDto,
  VendorCompanyCodeUpdateDto,
  VendorCompanyCodeExcelDownloadDto
> {
  service = inject(VendorCompanyCodeService);
  config = VENDORCOMPANYCODE_CONFIG;
  fields = VENDORCOMPANYCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorCompanyCodeDto): VendorCompanyCodeUpdateDto {
    return {
      companyCode: data.companyCode,
      withHoldingTaxCode: data.withHoldingTaxCode,
      withHoldingTaxType: data.withHoldingTaxType,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorCompanyCode';
  }
}
